module.exports = __webpack_public_path__ + "static/teper-trips-67a734c3091f48dce34dabd39a87a72e.webp";